import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { FaWhatsapp } from 'react-icons/fa';
import Navbar from './Components/Navabar/Navbar';
import Home from './Components/Home/Home';
import Footer from './Components/Footer/Footer';
import AboutUs from './Components/About Us/AboutUs';
import Career from './Components/Career/Career';
import ContactUs from './Components/Contact Us/ContactUs';
import PrivacyPolicy from './Components/Privacy Policy/PrivacyPolicy';
import TermsConditions from './Components/Terms Conditions/TermsConditions';
import ProductsServices from './Components/Products Services/ProductsServices';
import ServiceDetail from './Components/Products Services/ServiceDetail';

// Helper component
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />   {/*Always active */}
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="products" element={<ProductsServices />} />
        <Route path="about-us" element={<AboutUs />} />
        <Route path="career" element={<Career />} />
        <Route path="contact-us" element={<ContactUs />} />
        <Route path="privacy-policy" element={<PrivacyPolicy />} />
        <Route path="terms-conditions" element={<TermsConditions />} />
        <Route path="/services/:type" element={<ServiceDetail />} />
      </Routes>
      <Footer />
      
      {/* WhatsApp Floating Button */}
      <a 
        href="https://wa.me/93779897682" 
        className="whatsapp-float" 
        target="_blank" 
        rel="noopener noreferrer"
      >
        <FaWhatsapp className="whatsapp-icon" />
      </a>
    </Router>
  );
}

export default App;
